// extracted by mini-css-extract-plugin
export default {"block":"SandboxTitle_block__BPP7I","warningIcon":"SandboxTitle_warningIcon__TO1BS","title":"SandboxTitle_title__E94Tt"};